import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HcDropdown } from '@hotmart-org-ca/cosmos-web/dist/react/hc-dropdown';
export function Dropdown({ controls, children, className, position = 'bottom', ...rest }) {
    return (_jsxs(HcDropdown, { position: position, className: className, ...rest, children: [_jsx("div", { slot: "controls", children: controls }), children] }));
}
